import React from 'react';
import ReactDOM from 'react-dom';
import ChurchReserve from './App';

ReactDOM.render(
    <React.StrictMode>
        <ChurchReserve />
    </React.StrictMode>,
    document.getElementById('root')
);
